import { Utils } from "@/plugins/utils";
import router from '@/router';
import Enums from "../../plugins/Enums";
import axios from 'axios'

export default {
	namespaced: true,
	state: {
		lstLxi: [],
		lxi: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		cancelTokenSource: null
	},
	getters: {
		
	},
	mutations: {
		set(state, lxi){
			state.lxi = lxi
			if (lxi)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.lxi = null
			state.cancelTokenSource = null
		},
		setParamsDataTable(state, payload){
			state.lstLxi = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, lxitransac){
			return await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/Find/${lxitransac}`)
				.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, lxitransac){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", lxitransac)
			.then((lxi) => {
				store.commit("set", lxi)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.lxi.lxitransac){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/PaymentCondition/TEFTransaction/Insert", store.state.lxi )
			.then(async (response) => {
				Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/PaymentCondition/TEFTransaction/Update", store.state.lxi )
			.then(async (response) => {
				Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store, lxitransac){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/PaymentCondition/TEFTransaction/Delete/${lxitransac}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/PaymentCondition/TEFTransaction/FindList")
			.then(response => {
				let lstLxi = Utils.ValidateAxiosResponse(response.data);
				store.state.lstLxi = lstLxi
				store.state.hasNext = lstLxi.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstLxi = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstLxi = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async sendInstallmentsToTef(store, {cancelToken = "", option}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			let response = null;
			if(store.rootState.vd1.currentCv8Transaction.cv8codnfce == Enums.CodNFCE.PixDinamico || store.rootState.vd1.currentCv8Transaction.cv8codnfce == Enums.CodNFCE.PixEstatico){
				response = await store.dispatch("generatePixQrCode", cancelToken);
				if(!!response && !!response.lxi){
					store.rootState.vd1.showDialogPaymentProcessing = true
					response = await store.dispatch("verifyPixPayment", cancelToken)
				}
			} else {
				store.rootState.vd1.showDialogPaymentProcessing = true
				let payload = option ? {...store.rootGetters["vd1/handleCardTransactionModel"], AutomacaoColetaOpcao: option, automacaoColetaSequencial: store.rootState.vd1.currentCv8Transaction.cv8lastseq}
				: store.rootGetters["vd1/handleCardTransactionModel"]

				response = await store.dispatch("handleCardTransaction", {cancelToken, payload});
				if(response.hasGenerateTransac){
					payload = option ? {...store.rootGetters["vd1/handleCardTransactionModel"], AutomacaoColetaOpcao: option, automacaoColetaSequencial: store.rootState.vd1.currentCv8Transaction.cv8lastseq}
					: store.rootGetters["vd1/handleCardTransactionModel"]
					payload.isSecondStep = true
					response = await store.dispatch("handleCardTransaction", {cancelToken, payload});
				}
			}

			return response
		},
		async generatePixQrCode(store, cancelToken){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gerando Código PIX", indeterminate: true }, {root: true})

			const response = await this._vm.$tefAxios.post("/TEF/GeneratePixQrCode", store.rootGetters["vd1/GeneratePixQrCodeModel"], {
				cancelToken
			})
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);
				store.rootState.vd1.currentDialogPaymentInfo = payload

				store.rootState.vd1.lstCv8 = payload.lstCv8

				const sampleTransaction = store.rootState.vd1.lstCv8.find(el => el.cv8parcela == store.rootState.vd1.currentCv8Transaction.cv8parcela) 

				store.rootState.vd1.currentCv8Transaction = sampleTransaction

				store.rootState.vd1.pixTimerEnd = store.rootState.vd1.currentCv8Transaction.cv8vencim ?? Date.now();

				return payload
			})
			.catch((error) => {
				if(axios.isCancel(error))
					return false
				setTimeout(() => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				})
				return false
			});

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return response
		},
		async cancelTransaction(store, {cancelCurrentTransactionModel, closeDialog = true, isInSales = true, successMessage}){

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando Transação", indeterminate: true }, {root: true})
			const response = await this._vm.$tefAxios.post(`/TEF/CancelCurrentTransaction?isInSales=${isInSales}`, cancelCurrentTransactionModel)
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);
				
				if(closeDialog){
					store.rootState.vd1.currentDialogPaymentInfo = null
					store.rootState.vd1.currentCv8Transaction = null
					store.rootState.vd1.showDialogPaymentProcessing = false
				}

				store.rootState.vd1.lstCv8 = payload.lstCv8

				if(successMessage){
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 3000,
						text: successMessage,
						color: "#4CAF50"
					}, { root: true })
				}
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
						titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async verifyPixPayment(store, cancelToken){
			const lxh = store.rootState.lxh.lxh
			if(!!lxh)
				await store.dispatch("lxh/find", null, {root: true})

			const checkForTefTimeout = (message) => {
				if(lxh.lxhtef == Enums.TEFHouse.DESTAXA)
					return !message.includes("Código erro TEF: 9")
			}

			const response = await this._vm.$tefAxios.post("/TEF/FinishPixPayment", store.rootGetters["vd1/finishPixPaymentModel"], {
				cancelToken
			})
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);
				store.rootState.vd1.currentDialogPaymentInfo = payload

				store.rootState.vd1.lstCv8 = payload.lstCv8

				const sampleTransaction = store.rootState.vd1.lstCv8.find(el => el.cv8parcela == store.rootState.vd1.currentCv8Transaction.cv8parcela) 

				store.rootState.vd1.currentCv8Transaction = sampleTransaction
				
				store.dispatch("parameters/showSnackBar", {
					show: true,
					text: "Pagamento PIX confirmado",
					timeout: 6000,
					color: "#4CAF50",
				}, { root: true })
			
				store.rootState.vd1.showDialogPaymentProcessing = false

				if(!store.rootGetters['vd1/hasPendingTransactionWhileTef']){
					setTimeout(() => {
						store.rootState.vd1.showResume = true
					}, 0)
				}

				return payload
			})
			.catch((error) => {
				if(axios.isCancel(error))
					return false

				const isTimeout = checkForTefTimeout(error.message)
				if(isTimeout){
					store.dispatch("parameters/openDialog", {
							titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				}
				return false
			});

			return response
		},
		async handleCardTransaction(store, {cancelToken, payload}){
			const response = await this._vm.$tefAxios.post("/TEF/HandleCardTransaction", payload, {
				cancelToken
			})
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);
				store.rootState.vd1.currentDialogPaymentInfo = payload

				store.rootState.vd1.lstCv8 = payload.lstCv8

				const sampleTransaction = store.rootState.vd1.lstCv8.find(el => el.cv8parcela == store.rootState.vd1.currentCv8Transaction.cv8parcela) 

				store.rootState.vd1.currentCv8Transaction = sampleTransaction

				if(payload.automacaoColetaOpcao){
					setTimeout(() => {
						store.dispatch("parameters/openDialog", {
							show: true,
							titleText: payload.automacaoColetaMensagem,
							options: payload.automacaoColetaOpcao.split(";"),
							optionSelect: (option) => {
								store.dispatch("sendInstallmentsToTef", {cancelToken, option})
							}
						}, {root: true})
					})
					return true;
				}

				if(!payload.hasGenerateTransac){
					store.rootState.vd1.showDialogPaymentProcessing = false
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 6000,
						text: "Pagamento confirmado",
						color: "#4CAF50",
					}, { root: true })

					if(!store.rootGetters['vd1/hasPendingTransactionWhileTef']){
						setTimeout(() => {
							store.rootState.vd1.showResume = true
						}, 0)
					}
				}

				return payload
			})
			.catch((error) => {
				if(axios.isCancel(error))
					return false
				store.rootState.vd1.showDialogPaymentProcessing = false
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});

			return response
		},
		async collectCpf(store){
			store.dispatch("parameters/showSnackBar", {
				show: true,
				loading: true,
				text: "Cliente está informando CPF",
				color: "#EEEEEE",
				timeout: -1,
				textColor: "secondary"
			}, { root: true })
			const response =  await this._vm.$tefAxios.post("/TEF/CollectCpf/")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/showSnackBar", {
				show: false,
			}, { root: true })
			return response
		},
		async findByNsu(store, cv8nsu){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando Transação", indeterminate: true }, {root: true})
			const response = await this._vm.$tefAxios.post(`TEF/FindByNsu?lxinsu=${cv8nsu}?lxipedido=${store.vd1.vd1.vd1pedido}`,)
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);

				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async getSpecificReceipt(store, lxitransac){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Reimprimindo comprovante", indeterminate: true }, {root: true})
			const response = await this._vm.$tefAxios.get(`TEF/GetSpecificReceipt/${lxitransac}`,)
			.then(response => {
				const getSpecificReceiptResponse = Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async printTEFReceipt(store, { lxitransac, customerVia, establishmentVia}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Reimprimindo comprovante", indeterminate: true }, {root: true})
			const response = await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/PrintTEFReceipt/${lxitransac}?establishmentVia=${establishmentVia}&customerVia=${customerVia}`,)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async chargebackTransaction(store, lxitransac){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando transação", indeterminate: true }, {root: true})
			const response = await this._vm.$tefAxios.delete(`/TEF/ChargebackTransaction/${lxitransac}`,)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				if(!!payload.relatsPath && payload.relatsPath.length > 0){
					for (const relatPath of payload.relatsPath)
						store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				}

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async findByOrder(store, {lxipedido, lstLxistatus = null}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando Transação", indeterminate: true }, {root: true})

			let query = ""
			if (!!lstLxistatus && lstLxistatus.length > 0) {
				for (let index = 0; index < lstLxistatus.length; index++) {
					const lxistatus = lstLxistatus[index];
					query += `lstLxistatus=${lxistatus}&`
				}
			}

			const response = await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/FindByOrder/${lxipedido}?${query}`,)
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);

				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async findByStatus(store, {lstLxistatus = null}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando Transação", indeterminate: true }, {root: true})

			let query = ""
			if (!!lstLxistatus && lstLxistatus.length > 0) {
				for (let index = 0; index < lstLxistatus.length; index++) {
					const lxistatus = lstLxistatus[index];
					query += `lstLxistatus=${lxistatus}&`
				}
			}

			const response = await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/FindBystatus?${query}`,)
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);

				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		async findPendingTransactionOnNonBilledOrder(store, lxipedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando Transações Pendentes", indeterminate: true }, {root: true})

			const response = await this._vm.$axios.get(`/PaymentCondition/TEFTransaction/FindPendingTransactionOnNonBilledOrder?lxipedido=${lxipedido}`,)
			.then(response => {
				const payload = Utils.ValidateAxiosResponse(response.data);
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return response
		},
		initCancelTokenSource(store){
			const CancelToken = axios.CancelToken;
			store.state.cancelTokenSource = CancelToken.source();
			return true
		}
	}
}